jQuery(function ($){
  bsCustomFileInput.init()
});